import React, { useState } from "react";
import { HTMLRenderer } from "@gw/component-library";
import { NSSpecies } from "@gw/types";
import { ProfileDetailsStyled, ButtonsWrapper } from "./ProfileDetailsStyled";
var ProfileDetails = function (_a) {
    var summary = _a.summary, species_data = _a.species_data, founded = _a.founded;
    var _b = useState(0), activeTab = _b[0], setActiveTab = _b[1];
    return (React.createElement(ProfileDetailsStyled, null,
        React.createElement("div", { className: "mobile-view", id: "mobile-crops" },
            React.createElement(ButtonsWrapper, null,
                React.createElement("button", { onClick: function () {
                        setActiveTab(0);
                        window.location.href = "#mobile-crops";
                    }, className: activeTab === 0 ? "button-active" : "" }, "Crops"),
                React.createElement("button", { onClick: function () {
                        setActiveTab(1);
                        window.location.href = "#mobile-summary";
                    }, className: activeTab === 1 ? "button-active" : "" }, "About")),
            React.createElement(React.Fragment, null,
                species_data.length > 0 && (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "mobile-title" },
                        React.createElement("h2", null, "Available Crops"),
                        React.createElement("div", { className: "mobile-subtitle" },
                            React.createElement("h3", null, "Annual Yield"),
                            React.createElement("span", null, "(Wet lbs)"))),
                    React.createElement("div", null, species_data.map(function (element, index) {
                        var _a, _b, _c, _d;
                        return (React.createElement("div", { className: "mobile-table", key: index },
                            React.createElement("div", { className: "header-row" },
                                React.createElement("div", { className: "title-cell" },
                                    React.createElement("span", { className: "strong" }, (_a = NSSpecies.labels.speciesLabels.kelp[element.species]) === null || _a === void 0 ? void 0 : _a.name),
                                    " ",
                                    React.createElement("em", null, (_b = NSSpecies.labels.speciesLabels.kelp[element.species]) === null || _b === void 0 ? void 0 : _b.scientificName)),
                                React.createElement("span", { className: "strong yield" }, new Intl.NumberFormat("en-US").format(element.yield))),
                            React.createElement("div", { className: "body-row" },
                                React.createElement("span", { className: "strong" }, "Format Options"),
                                React.createElement("span", null, (_c = element.format) === null || _c === void 0 ? void 0 : _c.sort().map(function (format, index) {
                                    return NSSpecies.labels.formatLabels[format] +
                                        (index < element.format.length - 1 ? ", " : "");
                                }))),
                            React.createElement("div", { className: "body-row" },
                                React.createElement("span", { className: "strong" }, "Stability Options"),
                                React.createElement("span", null, (_d = element.stability) === null || _d === void 0 ? void 0 : _d.sort().map(function (stability, index) {
                                    return NSSpecies.labels.stabilityLabels[stability] +
                                        (index < element.stability.length - 1
                                            ? ", "
                                            : "");
                                })))));
                    })))),
                React.createElement("hr", null)),
            React.createElement(React.Fragment, null, summary && (React.createElement("div", { className: "summary", id: "mobile-summary" },
                React.createElement("h2", null, "About"),
                React.createElement("h3", null,
                    "Founded in ",
                    founded),
                React.createElement(HTMLRenderer, { htmlContent: summary }))))),
        React.createElement("div", { className: "desktop-view" },
            React.createElement(React.Fragment, null,
                species_data.length > 0 && (React.createElement(React.Fragment, null,
                    React.createElement("h2", null, "Available Crops"),
                    React.createElement("div", { className: "table-header" },
                        React.createElement("div", { className: "header-cell" }, "Crop"),
                        React.createElement("div", { className: "header-cell" }, "Format"),
                        React.createElement("div", { className: "header-cell" }, "Stability"),
                        React.createElement("div", { className: "header-cell" },
                            "Est. Yield",
                            React.createElement("span", null, "(Wet lbs)"))),
                    React.createElement("div", { className: "table-body" }, species_data.map(function (element, index) {
                        var _a, _b, _c, _d;
                        return (React.createElement(React.Fragment, { key: index },
                            React.createElement("div", { className: "body-cell" },
                                React.createElement("span", { className: "strong" }, (_a = NSSpecies.labels.speciesLabels.kelp[element.species]) === null || _a === void 0 ? void 0 : _a.name),
                                " ",
                                React.createElement("em", null, (_b = NSSpecies.labels.speciesLabels.kelp[element.species]) === null || _b === void 0 ? void 0 : _b.scientificName)),
                            React.createElement("div", { className: "body-cell" },
                                React.createElement("span", null, (_c = element.format) === null || _c === void 0 ? void 0 : _c.map(function (format, index) {
                                    return NSSpecies.labels.formatLabels[format] +
                                        (index < element.format.length - 1 ? ", " : "");
                                }))),
                            React.createElement("div", { className: "body-cell" },
                                React.createElement("span", null, (_d = element.stability) === null || _d === void 0 ? void 0 : _d.map(function (stability, index) {
                                    return NSSpecies.labels.stabilityLabels[stability] +
                                        (index < element.stability.length - 1 ? ", " : "");
                                }))),
                            React.createElement("div", { className: "body-cell" },
                                React.createElement("span", { className: "strong" }, new Intl.NumberFormat("en-US").format(element.yield)))));
                    })),
                    React.createElement("div", { className: "table-footer" },
                        React.createElement("div", { className: "footer-cell" },
                            React.createElement("span", { className: "strong" }, "Total Est. Yield")),
                        React.createElement("div", { className: "footer-cell" }),
                        React.createElement("div", { className: "footer-cell" }),
                        React.createElement("div", { className: "footer-cell" }, new Intl.NumberFormat("en-US").format(species_data
                            .map(function (element) { return element.yield; })
                            .reduce(function (prev, element) { return prev + element; })))))),
                summary && (React.createElement("div", { className: "summary" },
                    React.createElement("h2", null, "About"),
                    React.createElement("h3", null,
                        "Founded in ",
                        founded),
                    React.createElement(HTMLRenderer, { htmlContent: summary })))))));
};
export default ProfileDetails;
//# sourceMappingURL=ProfileDetails.js.map